export enum ContentOverTimeDurationTypeEnum {
    CURRENT_MONTH = 'CURRENT_MONTH',
    LAST_24_HOURS = 'LAST_24_HOURS',
}
